module.exports = __webpack_public_path__ + "img/rental_bicycle.8d39b42c.svg";